import { Modal, Form, Input } from '@pankod/refine-antd'

import { SelectBidangStudyOptions } from '../SelectLPTKDataOptions'
import { phone } from 'src/helpers/validator'

export type ModalFormGuruPamongProps = {
  modalProps: any
  formProps: any
  onSubmit?: () => void
  mode: 'create' | 'edit'
  lptkId: string | number
}

export const ModalFormGuruPamong = (props: ModalFormGuruPamongProps) => {
  const { modalProps, formProps, mode, onSubmit } = props

  return (
    <Modal
      {...modalProps}
      title={mode === 'create' ? 'Tambah Guru Pamong Baru' : 'Edit Guru Pamong'}
      okText="Simpan"
      cancelText="Kembali"
      {...(onSubmit && {
        okButtonProps: {
          onClick: async () => {
            const data = await onSubmit()
            formProps.onFinish(data)
          },
        },
      })}
    >
      <Form
        {...formProps}
        {...(mode === 'edit' && {
          initialValues: {
            ...formProps.initialValues?.data,
            schoolId: formProps.initialValues?.data?.school?.id,
          },
        })}
        layout="vertical"
        validateMessages={{ required: '${label} must be filled.' }}
      >
        <Form.Item
          label="Name"
          name="name"
          required
          rules={[{ required: true }]}
        >
          <Input autoComplete="off" />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          required
          rules={[
            { required: true },
            { type: 'email', message: '${label} format is invalid.' },
          ]}
        >
          <Input autoComplete="off" disabled={mode === 'edit'} />
        </Form.Item>
        <Form.Item
          label="No HP"
          name="phone"
          required
          rules={[
            { required: true },
            {
              validator: (_, value) => phone(value),
              message: '${label} format is invalid.',
            },
          ]}
        >
          <Input autoComplete="off" />
        </Form.Item>
        <Form.Item
          label="bidang studi"
          name="studyField"
          required
          rules={[{ required: true }]}
        >
          <SelectBidangStudyOptions visible={modalProps.visible} />
        </Form.Item>
        <Form.Item label="UKG (Optional)" name="ukg">
          <Input autoComplete="off" />
        </Form.Item>
        {/* <Form.Item
          label="Asal Sekolah"
          name="schoolId"
          required
          rules={[{ required: true }]}
        >
          <SelectSchoolOptions lptkId={lptkId} visible={modalProps.visible} />
        </Form.Item> */}
      </Form>
    </Modal>
  )
}
